import { useCallback, useContext } from 'react'
import { AppStateContext } from './AppStateContext'

interface IsRefreshResult {
  saveIsRefresh: (isRefresh: boolean | undefined) => void
  removeIsRefresh: () => void
}

export const useRefresh: () => IsRefreshResult = () => {
  const { setIsRefreshInStore, removeIsRefreshFromStore } = useContext(AppStateContext)
  const saveIsRefresh = useCallback(
    (isRefresh: boolean | undefined) => setIsRefreshInStore(isRefresh),
    [setIsRefreshInStore],
  )

  const removeIsRefresh = useCallback(() => removeIsRefreshFromStore(), [removeIsRefreshFromStore])

  return {
    saveIsRefresh,
    removeIsRefresh,
  }
}
